export default __webpack_public_path__ + "static/media/subscribe.b45747d5.svg";